import { Inject, Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { ConcernedService } from './concerned.service'
import { ConcernedDetailsMsg, ConcernedSubjectFullDto } from '../../../api/backend'
import { ConcernedViewActions } from '../state/concerned-view/action-types'

@Injectable({
    providedIn: 'root'
})
export class ConcernedDatastoreService {

    concernedDetails: ConcernedDetailsMsg
    allConcerned = []

    constructor(@Inject(Store) private store: Store,
                @Inject(ConcernedService) private concernedService: ConcernedService) {
    }

    public getConcernedDetails(): Promise<ConcernedDetailsMsg> {
        return new Promise((resolve) => {
            if (!this.concernedDetails) {
                (this.concernedService.getConcernedDetails()).subscribe(data => {
                    this.concernedDetails = data

                    this.store.dispatch(ConcernedViewActions.setConcernedDetails({ data }))
                    resolve(data)
                })
            } else {
                resolve(this.concernedDetails)
            }
        })
    }

    public getAllConcerned(): Promise<Array<ConcernedSubjectFullDto>> {
        return new Promise((resolve) => {
            if (!this.allConcerned?.length) {
                this.concernedService.fetchAllConcerned().subscribe(data => {
                    const filteredData = data.filter( c => c.lpisUserId || c.opsubId > 0)
                    this.allConcerned = filteredData
                    this.store.dispatch(ConcernedViewActions.setAllConcerned({ data: filteredData }))
                    resolve(filteredData)
                })
            } else {
                resolve(this.allConcerned)
            }
        })
    }

    public reset(): void {
        this.concernedDetails = null
        this.allConcerned = []

        this.store.dispatch(ConcernedViewActions.resetState())
    }

}
